import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import Footer from './global/Footer';
import Header from './global/Header';

const AppLayout = ({ children }) => {
  const location = useLocation();
  const [isPortfolio, setIsPortfolio] = useState('fixed');

  // useEffect(() => {
  //   const portfolio = location.pathname;
  //   if(portfolio === '/portfolio'){
  //     setIsPortfolio('fixed');
  //   } else {
  //     setIsPortfolio('unset');
  //   }
  // }, [location])

  const theme = useSelector((state) => state.header.theme);
  return (
    <>
      <Header theme={theme} background="background" />
      {children}
      <Footer theme={theme} position={isPortfolio} />
    </>
  );
};

export default AppLayout;
